function openNav() {
	document.getElementById("myNav").style.width = "100%"
}

function closeNav() {
	document.getElementById("myNav").style.width = "0%"
}
window.onload = function(){
  (function(){
      var t = document.querySelector(".gallery_box .flexbox");
      new Masonry(t, {
          itemSelector: ".item"
      })
	})();

}
$(document).ready(function() {
	$(".product_tab ul.tabs li").click(function() {
		$(".product_tab ul.tabs li").css("pointer-events", "none");
		$(this).parent().find(".current").removeClass("current"), $(this).addClass("current"), event.preventDefault();
		var t = $(this).attr("data-url");
		return history.pushState && history.pushState({
			url: t
		}, t, t), $("#product_container").load(" .col_prod_tab"), setTimeout(function() {
			$(".product_tab ul.tabs li").css("pointer-events", "all")
		}, 300), !1
	}), $(".video_slider").slick({
		dots: !1,
		infinite: !0,
		speed: 1e3,
		autoplay: !1,
		arrows: !0,
		slidesToShow: 1,
		fade: !0,
		slidesToScroll: 1,
		nextArrow: '<button type="button" class="slick-next pull-right"><img src="https://cdn.shopify.com/s/files/1/0557/0992/5585/files/right.png?v=1619519856"></button>',
		prevArrow: '<button type="button" class="slick-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0557/0992/5585/files/left.png?v=1619519856"></button>'
	}), $(".video_slider").on("afterChange", function(t, e, o) {
		$(".video_slider .slick-slide lite-youtube").removeClass("lyt-activated"), $(".video_slider .slick-slide lite-youtube iframe").remove()
	}), $(".readmore").click(function(t) {
		t.preventDefault(), document.querySelector(".description-full").style.display = "block", document.querySelector(".description-short").style.display = "none"
	}), $(".readless").click(function(t) {
		t.preventDefault(), document.querySelector(".description-full").style.display = "none", document.querySelector(".description-short").style.display = "block"
	}), $(".pdp-alter-thumb-img").click(function() {
		var t = $(this).attr("src");
		$(".pdp-alter-img-main img").attr("src", t)
	}), $(".breed-thumb-img").click(function() {
		var t = $(this).attr("src");
		$(".breed-main-img").attr("src", t)
	}), $(".parent_links_mob > li > a").click(function() {
		$(this).parent("li").children(".child_links_mob").toggleClass("active")
	}), $(".readless").click(function() {
		setTimeout(function() {
			$("html, body").animate({
				scrollTop: $("#artical_des").offset().top
			})
		}, 100)
	}), $(".set > h4").on("click", function() {
		$(this).hasClass("active") ? ($(this).removeClass("active"), $(this).siblings(".content").slideUp(200), $(".set > h4 i").removeClass("fa-minus").addClass("fa-plus")) : ($(".set > h4 i").removeClass("fa-minus").addClass("fa-plus"), $(this).find("i").removeClass("fa-plus").addClass("fa-minus"), $(".set > h4").removeClass("active"), $(this).addClass("active"), $(".content").slideUp(200), $(this).siblings(".content").slideDown(200))
	}), $(".prod_main_img_slide").slick({
		arrows: !1,
		dots: !1,
		infinite: !1,
		autoplay: !0,
		autoplaySpeed: 2500,
		speed: 300,
		fade: !0,
		slidesToShow: 1,
		adaptiveHeight: !0,
		asNavFor: ".thumb_slider_prod",
		centerMode: !1
	}), $(".thumb_slider_prod").slick({
		infinite: !1,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: !0,
		vertical: !0,
		asNavFor: ".prod_main_img_slide",
		responsive: [{
			breakpoint: 993,
			settings: {
				arrows: !0,
				slidesToShow: 3
			}
		}, {
			breakpoint: 769,
			settings: {
				arrows: !0,
				slidesToShow: 4,
				vertical: !1
			}
		}, {
			breakpoint: 481,
			settings: {
				arrows: !0,
				slidesToShow: 3,
				vertical: !1
			}
		}]
	}), $(".thumb_slider_prod  .product-single__thumbnails-item").click(function() {
		var t = $(this).attr("data-slick-index");
		$(".prod_main_img_slide").slick("slickGoTo", t)
	}), $(".click-to-show").click(function(t) {
		$(this);
		if ("close-btn" != $(t.target).attr("id")) {
			var e = JSON.parse($(this).closest(".team_member").find("script").html());
			$(".bio_img img").attr("src", e.image), $(".bio_img img").attr("alt", e.image_alt), $(".bio_desc .member_title").text(e.name), $(".bio_desc .member_detail").html(e.description), $("#div-to-toggle").show(), $("body").addClass("body_overlay"), event.stopPropagation()
		}
	}), $("#div-to-toggle").click(function(t) {
		"close-btn" != $(t.target).attr("id") && ($("#div-to-toggle").show(), $("body").addClass("body_overlay"), event.stopPropagation())
	}), $("body, #close-btn").click(function() {
		$("#div-to-toggle").hide(), event.stopPropagation()
	}), $("#close-btn").click(function() {
		$("body").removeClass("body_overlay")
	});
// 	var t = document.querySelector(".gallery_box .flexbox");
// 	new Masonry(t, {
// 		itemSelector: ".item"
// 	})
}), AOS.init({
	duration: 1e3,
	delay: 100,
	once: !0
}), $(window).bind("load", function() {
	$(".loader-wrp").fadeOut()
}), jarallax(document.querySelectorAll(".jarallax"), {
	speed: .2
});
let scaleAmount = .4;

function scrollZoom() {
	const t = document.querySelectorAll("[data-scroll-zoom]");
	let e = 0;
	scaleAmount /= 100;
	const o = {
		rootMargin: "0% 0% 0% 0%",
		threshold: 0
	};

	function i(t) {
		const e = t.parentNode,
			o = window.innerHeight,
			i = window.scrollY,
			s = e.getBoundingClientRect().top + i,
			l = parseFloat(getComputedStyle(e).getPropertyValue("border-bottom-width")) + parseFloat(getComputedStyle(t).getPropertyValue("border-top-width")),
			r = e.offsetHeight + l;
		if (s > i + o) return 0;
		if (s + r < i) return 100; {
			let t = (i + o - s) / ((o + r) / 100);
			return t = Math.round(t)
		}
	}
	t.forEach(t => {
		let s = !1;
		new IntersectionObserver((t, e) => {
			t.forEach(t => {
				s = t.isIntersecting
			})
		}, o).observe(t), t.style.transform = `scale(${1+scaleAmount*i(t)})`, window.addEventListener("scroll", () => {
			s && (e = window.pageYOffset, t.style.transform = `scale(${1+scaleAmount*i(t)})`)
		})
	})
}
scrollZoom();